import { SxProps } from '@mui/material';
import { black1, grey11, grey11Opacity85, grey3, red2 } from 'app/components/ThemeProvider/colors';
import { CSSProperties } from 'react';
import { getTheme } from '../../../components/ThemeProvider/theme';

const theme = getTheme('light');
export const accountBox: SxProps = {
  background: grey11,
  padding: '8px 16px',
  borderRadius: '8px',
  marginBottom: '24px',
  cursor: 'pointer',
};

export const bottomBtns: SxProps = {
  display: 'flex',
  gap: '12px',
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
  },
};

export const labelStyle: CSSProperties = {
  fontFamily: 'Yelo',
  color: 'rgba(20, 25, 31, 0.40)',
  fontSize: '13px',
  width: '100%',
  cursor: 'pointer',
};

export const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    background: '#F6F7F8',
    fontFamily: 'Yelo',
    color: black1,
    minHeight: '24px',
    maxHeight: '24px',
    height: '24px',
    cursor: 'pointer',
    borderRadius: 'none',
    border: 'none',

    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      borderColor: 'transparent',
    },
  }),

  container: (base: any) => ({
    ...base,
    height: '24px',
  }),
  menu: (base: any, state: any) => ({
    ...base,

    borderRadius: '8px',
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
    marginTop: 0,
    padding: 0,
  }),
  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    background: 'transparent',
    fontWeight: state.getValue().length === 1 ? 500 : state.getValue() === 'All selected' ? 500 : 600,
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
  }),

  multiValue: (base: any) => ({
    ...base,
    background: 'transparent',
    width: '100%',
    margin: 0,
  }),

  multiValueLabel: (base: any) => ({ ...base, padding: 0, paddingLeft: 0, fontSize: '16px', width: '96%' }),

  placeholder: (base: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    fontWeight: 500,
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: 0,
    height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    padding: 0,
    position: 'absolute',
    right: '-4px',
    bottom: '12px ',
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    color: black1,
    '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
  }),
};

export const balanceText: SxProps = {
  color: grey3,
  fontSize: '17px',
  mb: '8px',
};

export const balanceAmount: SxProps = {
  color: black1,
  fontSize: '44px',
  fontWeight: '600',
  lineHeight: '1',
};

export const docInfoBox: SxProps = {
  background: grey11Opacity85,
  borderRadius: '8px',
  display: 'flex',
  gap: '8px',
  p: '8px 12px',
  alignItems: 'center',
  height: '35px',

  '&:hover': {
    cursor: 'pointer',
  },
};

export const docInfoText: SxProps = {
  fontSize: '15px',
  color: red2,
  lineHeight: '1',
};

export const lineBorder: SxProps = {
  border: '1px dashed #eaeaea',
  width: '100%',
  mb: '24px',
};

export const infoBox = (expand: boolean) => {
  return {
    display: 'flex',
    gap: expand ? '24px' : '80px',
    mb: '24px',
  };
};
